import Immutable from 'seamless-immutable';
import _ from 'lodash';

/**
 * AccountPrivateKeyModel is a model that represents the private API key for an account. It is used to store and manage the private API key securely, as it is not included in the main account data that is used across the app.
 * @typedef {Object} AccountPrivateKeyModel
 * @property {string} privateApikey - the private API key for the account, this is a secure value that is not included in the main account data
 */

/**
 * Create an AccountPrivateKeyModel from provided data
 * @param {Object} account - the account as a POJO
 */
function create(account) {
  return Immutable(account);
}

/**
 * Transform a backend account object into a frontend AccountPrivateKeyModel
 * @param {Object} account - backend formatted account
 * @returns {AccountPrivateKeyModel}
 */
function deserialize(account) {
  const result = _.pick(account, _keys);
  return create(result);
}

const _keys = ['privateApikey'];

export default {
  create,
  deserialize,
};
